import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export default function ShopLoginForm() {
    const formRef = useRef(null);
    const { fetchTokenData } = useSelector(state => state.authShop);

    useEffect(() => {
        if (fetchTokenData) {
            const { token, authURL } = fetchTokenData;
            console.log('ShopLoginForm submitting to authURL:', authURL);
            formRef.current.action = authURL;
            formRef.current.token.value = token;
            formRef.current.submit();
        }
    }, [fetchTokenData]);

    return (
        <form
            ref={formRef}
            name="form"
            method="POST"
            target="_top"
            style={{ display: 'none' }}
        >
            <input type="hidden" name="token" id="token" value={fetchTokenData} />
        </form>
    );
}
